import React from "react";
import {IonProgressBar} from "@ionic/react";
import {formDefFazenda, formDefFazendaCorte, formDefFazendaLeite} from "./forms";
import {QuestionarioFazendaObject} from "../../../models/Questionario";
import {EventoObject} from "../../../models/Evento";
import FieldView from "../../../components/FieldView";
import {ModelForm, ModelFormField, ModelFormProps, buildModelForm} from "../../../components/ModelFormHOC";
import fb from "../../../lib/firebase";
import {listaVacinaReprodutiva, listaMineralInjetavel, listaVacinaDiarreiaPneumonia, FormVersao} from "./forms";
import {FazendaObject} from "../../../models/Fazenda";
import FormQuestionarioCorte from "./Fazenda/FormQuestionarioCorte";
import FormQuestionarioLeite from "./Fazenda/FormQuestionarioLeite";
import {FormDefinition} from "../../../lib/forms";
import {AppState} from "../../../models/app";
import {AppDispatch, RootState} from "../../../global.state";
import {connect} from "react-redux";
import omit from 'lodash/omit';


interface Props extends  ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  evento: EventoObject | undefined;
  principal: FazendaObject;
  instance?: QuestionarioFazendaObject;
  onSubmit: () => void;
}

interface State {
  formDef: FormDefinition | undefined;
}

class _FormQuestionarioFazenda extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);

    this.state = {
      formDef: undefined,
    };
  }

  componentDidMount() {
    this.setFormDef();
  }

  componentDidUpdate(prevProps:Props) {
    if (prevProps.principal && prevProps.principal.tipo && prevProps.principal.tipo !== this.props.principal.tipo) {
      this.setFormDef();
    }
  }

  setFormDef = () => {
    const {principal} = this.props;

    let formDef = {...formDefFazenda};
    if (principal.tipo.indexOf('Corte') !== -1) {
      formDef = {...formDef, ...formDefFazendaCorte};

      // remover campos sem uso
      formDef = omit(formDef, ['femeas_idade_reprodutiva', 'touros']);

      if (principal.sistema_producao.indexOf('Cria') !== -1) {
        formDef = {
          ...formDef,
          corte_cria_vacas: {
            ...formDef.corte_cria_vacas,
            required: true,
          },
          corte_cria_novilhas: {
            ...formDef.corte_cria_novilhas,
            required: true,
          },
          corte_cria_bezerros: {
            ...formDef.corte_cria_bezerros,
            required: true,
          },
          corte_cria_touros: {
            ...formDef.corte_cria_touros,
            required: true,
          },
        };
      }

      if (principal.sistema_producao.indexOf('Recria') !== -1) {
        formDef = {
          ...formDef,
          corte_recria_novilhas: {
            ...formDef.corte_recria_novilhas,
            required: true,
          },
          corte_recria_garrotes: {
            ...formDef.corte_recria_garrotes,
            required: true,
          },
        };
      }

      if (principal.sistema_producao.indexOf('Engorda') !== -1) {
        formDef = {
          ...formDef,
          corte_engorda_bois: {
            ...formDef.corte_engorda_bois,
            required: true,
          },
          corte_engorda_femeas: {
            ...formDef.corte_engorda_femeas,
            required: true,
          },
        };
      }

      if (principal.sistema_producao.indexOf('Confinamento') !== -1) {
        formDef = {
          ...formDef,
          corte_confinamento_machos: {
            ...formDef.corte_confinamento_machos,
            required: true,
          },
          corte_confinamento_femeas: {
            ...formDef.corte_confinamento_femeas,
            required: true,
          },
        };
      }
    }
    if (this.props.principal.tipo.indexOf('Leite') !== -1) {
      formDef = {...formDef, ...formDefFazendaLeite};
    }

    this.setState({
      formDef,
    });
  };

  // noinspection DuplicatedCode
  onCreate = (values:any) => {
    values.principal = fb.db.doc(this.props.principal.path);
    values.tipo = 'fazendas';
    values.versao = FormVersao.fazendas;
    values.evento = {
      label: fb.eventos.label(this.props.evento!),
      path: fb.db.collection('eventos').doc(this.props.evento!.id),
    };

    return fb.document.create('questionarios', this.totalizarRebanho(values));
  };

  onUpdate = (values:any) => {
    values.versao = FormVersao.fazendas;

    return fb.document.update(
      'questionarios',
      this.props.instance!.id,
      this.totalizarRebanho(values),
    );
  };

  totalizarRebanho = (values:QuestionarioFazendaObject): any => {
    const {principal} = this.props;

    let quantidade_animais = 0;

    if (principal.tipo.indexOf('Corte') !== -1) {
      if (principal.sistema_producao.indexOf('Cria') !== -1) {
        quantidade_animais += values.corte_cria_vacas;
        quantidade_animais += values.corte_cria_novilhas;
        quantidade_animais += values.corte_cria_bezerros;
        quantidade_animais += values.corte_cria_touros;
      }
      if (principal.sistema_producao.indexOf('Recria') !== -1) {
        quantidade_animais += values.corte_recria_novilhas;
        quantidade_animais += values.corte_recria_garrotes;
      }
      if (principal.sistema_producao.indexOf('Engorda') !== -1) {
        quantidade_animais += values.corte_engorda_bois;
        quantidade_animais += values.corte_engorda_femeas;
      }
      if (principal.sistema_producao.indexOf('Confinamento') !== -1) {
        quantidade_animais += values.corte_confinamento_machos;
        quantidade_animais += values.corte_confinamento_femeas;
      }
    }

    if (principal.tipo.indexOf('Leite') !== -1) {
      quantidade_animais += values.vacas_ordenhadas;
      quantidade_animais += values.leite_vacas_secas;
      quantidade_animais += values.leite_novilhas;
      quantidade_animais += values.leite_bezerras;
    }

    return {
      ...values,
      quantidade_animais,
    };
  };

  render() {
    if (!this.props.principal || !this.props.evento || this.state.formDef === undefined)
      return <IonProgressBar type="indeterminate"/>;

    const {principal} = this.props;

    return (
      <>
        <div className="flex flex-wrap">
          <div className="flex-grow">
            <FieldView value={this.props.principal.nome}
                       label={`Fazenda (${principal.tipo.join(', ')})`}/>
          </div>
          <div className="flex-shrink">
            <FieldView value={this.props.evento.data} label="Data evento"
                       type="date" format="DD/MM/YYYY"/>
          </div>
        </div>

        {this.state.formDef !== undefined &&
          <ModelForm
            key={this.props.principal.id}
            entityLabel="Questionário"
            ownerId={this.props.app.user.uid}
            gender="m"
            instance={this.props.instance}
            formDefinition={this.state.formDef}
            onCreate={this.onCreate}
            onUpdate={this.onUpdate}
            onComplete={this.props.onSubmit}
          >
            {
              principal.tipo.indexOf('Corte') !== -1 &&
              <FormQuestionarioCorte fazenda={principal}/>
            }

            {
              principal.tipo.indexOf('Leite') !== -1 &&
              <FormQuestionarioLeite fazenda={principal}/>
            }

            <div className="text-xl font-hairline mt-6">
              Produtos utilizados
            </div>
            <ModelFormField
              field="vacina_reprodutiva"
              options={listaVacinaReprodutiva}
            />
            <ModelFormField
              field="vacina_diarreia_pneumonia"
              options={listaVacinaDiarreiaPneumonia}
            />
            <ModelFormField
              field="mineral_injetavel"
              options={listaMineralInjetavel}
            />

            <div className="text-xl font-hairline mt-6">
              Demais informações
            </div>
            <ModelFormField field="faz_iatf" className="mt-2"/>
            <ModelFormField field="observacoes"/>
          </ModelForm>
        }
      </>
    )
  }
}

export const FormQuestionarioFazenda = connect(({app}: RootState) => ({app}))(buildModelForm(_FormQuestionarioFazenda));
